import * as React from 'react';
const LocationIcon = ({ width = 18, height = 18, ...props }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 18 18'
    fill='none'
    {...props}
  >
    <path
      d='M9 10.628A2.898 2.898 0 1 1 9 4.83a2.898 2.898 0 1 1 0 5.798m0-4.673a1.776 1.776 0 1 0-.002 3.557A1.776 1.776 0 0 0 9 5.955'
      fill='currentColor'
    />
    <path
      d='M9 17.07c-1.11 0-2.227-.42-3.097-1.252-2.213-2.13-4.658-5.528-3.735-9.57C3 2.58 6.203.938 9 .938h.008c2.797 0 6 1.642 6.832 5.317.915 4.042-1.53 7.433-3.742 9.563A4.48 4.48 0 0 1 9 17.07M9 2.063c-2.182 0-4.987 1.162-5.73 4.432-.81 3.532 1.41 6.578 3.42 8.505a3.32 3.32 0 0 0 4.628 0c2.002-1.928 4.222-4.972 3.427-8.505-.75-3.27-3.562-4.432-5.745-4.432'
      fill='currentColor'
    />
  </svg>
);
export default LocationIcon;
